<!--
Author: TangChen
Date: 2019-10-24
Desc: 经办人信息
 -->
<template>
    <div :class="'view-agent-info view bg-white' + className">
        <comp-title :title="title" />
        <nav-bar v-if="navs.length>1" :navs="navs" />
        <div class="agent-form">
            <el-form
                ref="agentInfo"
                :model="agentInfo"
                :rules="rules"
                label-width="370px"
                class="demo-agentInfo"
                v-on:submit.native.prevent
            >
                <el-form-item label="经办人姓名" prop="userName">
                    <el-input v-model.trim="agentInfo.userName" placeholder="经办人姓名" />
                </el-form-item>
                <el-form-item label="开户证件" prop="certType">
                    <el-select
                        v-model="agentInfo.certType"
                        placeholder="请选择证件类型"
                        v-on:change="checkCertNoAgain"
                    >
                        <el-option
                            v-for="item in certTypes"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="证件号码" prop="certNo">
                    <el-input
                        v-model.trim="agentInfo.certNo"
                        :placeholder="'请' + holderText + '证件号码'"
                        :maxlength="18"
                    />
                </el-form-item>
                <el-form-item v-if="dateSet.max" label="证件有效期" prop="validdate">
                    <date-picker :date="dateSet" v-on:date-get="dateInterval" />
                </el-form-item>
                <el-form-item label="手机号码" prop="mobile">
                    <el-select
                        v-model="agentInfo.mobilecycode"
                        placeholder="请选择国家码"
                        style="width:150px!important"
                        :disabled="true"
                    >
                        <el-option
                            v-for="item in mobilecycode"
                            :key="item.subitem"
                            :label="item.subitemname+' '+item.subitem"
                            :value="item.subitem"
                        />
                    </el-select>
                    <el-input style="'width: 210px'" v-model.trim="agentInfo.mobile" placeholder="请输入手机号码" :maxlength="11" />
                </el-form-item>
                <el-form-item label="手机验证码" prop="verifyCode">
                    <el-input
                        v-model.trim="agentInfo.verifyCode"
                        placeholder="请输入手机验证码"
                        :maxlength="6"
                    >
                        <el-button
                            slot="append"
                            class="get-verify"
                            :disabled="time>0"
                            v-on:click="mobileCheck"
                        >
                            {{ btnMsg }}
                        </el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="电子邮箱" prop="email">
                    <el-input v-model.trim="agentInfo.email" :disabled="!checked" placeholder="请输入电子邮箱" :maxlength="32" />
                </el-form-item>
                <el-form-item label="输入密码" prop="pwd">
                    <el-input
                        v-model.trim="agentInfo.pwd"
                        :type="pwdType"
                        placeholder="请输入登录密码"
                        :disabled="!checked"
                        :maxlength="16"
                    >
                        <i slot="suffix" :class="iconCla" v-on:click="pwdTypeChange" />
                    </el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="confirmPwd">
                    <el-input
                        v-model.trim="agentInfo.confirmPwd"
                        :type="pwdType"
                        :disabled="!checked"
                        placeholder="请再输入一次登录密码"
                        :maxlength="16"
                    >
                        <i slot="suffix" :class="iconCla" v-on:click="pwdTypeChange" />
                    </el-input>
                </el-form-item>
                <el-form-item v-if="hasAgr" label="" prop="type" class="agree">
                    <el-checkbox-group v-model="agentInfo.type">
                        <agreement :data="agrType" v-on:protocol="protocol" />
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item class="margin-top">
                    <el-button type="yellow" class="medium" v-on:click.prevent="submitForm('agentInfo')">
                        下一步
                    </el-button>
                    <el-button class="medium" type="back" v-on:click.prevent="$router.back()">
                        返回
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <img-code :dialog-visible="visible" v-on:verify-in="getVerifyCode" />
        <!--内容-->
    </div>
</template>

<script>
    import mixin from "@/assets/js/mixin";
    import navBar from "@/components/common/navBar.vue";
    import imgCode from "@/components/common/imgCode.vue";
    import datePicker from "@/components/common/datePicker.vue";
    import agreement from "@/components/common/agreement.vue";
    export default {
        name: "ViewAgentInfo",
        components: {
            navBar,
            datePicker,
            agreement,
            imgCode
        },
        mixins: [mixin],
        data () {
            return {
                hasAgr: true, // 是否需要签署协议
                isTaTwo: true,
                agrType: "register", // 协议类型，注册协议
                mobilecycode: [],
                navs: [
                    {id: "1",val: "经办人信息",active: "1"},
                    {id: "2",val: "基本信息"},
                    {id: "3",val: "信息登记"},
                    {id: "4",val: "银行信息"},
                    {id: "5",val: "文件上传"},
                    {id: "6",val: "完成注册",icon: "fa fa-check"}
                ],
                agentInfo: {
                    userName: "",
                    certType: "0",
                    certNo: "",
                    validdate: "",
                    verifyCode: "",
                    email: "",
                    mobilecycode: "86",
                    mobile: "",
                    pwd: "",
                    confirmPwd: "",
                    type: ""
                },
                visible: false,
                rules: {
                    userName: [
                        { validator: this.$util.validateName, trigger: "change" }
                    ],
                    certType: [
                        { required: true, message: "请选择证件类型", trigger: "change" }
                    ],
                    certNo: [
                        { required: true, message: "请输入证件号码", trigger: "blur" },
                        { validator: this.checkCertNo, trigger: "blur" }
                    ],
                    validdate: [
                        { required: true, message: "请选择证件有效期", trigger: "change" }
                    ],
                    mobilecycode: [
                        { required: true, message: "请选择国家码", trigger: "change" }
                    ],
                    mobile: [
                        { required: true, message: "请输入手机号码", trigger: "blur" },
                        { validator: this.$util.validateMobile, trigger: "blur" }
                    ],
                    verifyCode: [
                        { validator: this.$util.validateVerifyCode, trigger: "blur" }
                    ],
                    email: [
                        { validator: this.$util.validateEmail, trigger: "blur" }
                    ],
                    pwd: [
                        { validator: this.$util.validatePwd, trigger: "blur" },
                        { validator: this.pwdCheck, trigger: "blur" }
                    ],
                    confirmPwd: [
                        { validator: this.$util.validatePwd, trigger: "blur" },
                        { validator: this.confirm, trigger: "blur" }
                    ],
                    type: [
                        { validator: this.checkProtocol, trigger: "change" }
                    ]
                },
                file: {},
                fileName: "",
                iconCla: "fa fa-eye-slash", // 密码输入框图标
                pwdType: "password", // 密码输入框类型
                time: 0,
                btnMsg: "获取验证码",
                checked: true, // 是否已经验证手机号码
                ocrBtnText: "上传",
                holderText: "输入",
                certTypes: [], // 证件类型
                dateSet: { type: "3", max: "", val: "",text: "请选择证件有效期" },
                ocrupdflag: "0" //上传成功标示
            };
        },
        watch: {
            "agentInfo.certNo"(val){
                if(this.agentInfo.certType === "0" && val.indexOf("x") > -1){
                    this.$set(this.agentInfo,"certNo",val.replace("x","X"));
                }
            },
            "agentInfo.mobile"(val){
                this.mustNum(val, "mobile");
            }

        },
        mounted() {
            this.isTaTwo = sessionStorage.getItem("isTaTwo", "") || true;
            this.certTypes = this.$cache.getDict("130007");
            this.mobilecycode = this.$cache.getDict("150136");
            const conf = this.$util.getConfig().const;
            this.dateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        },
        methods: {
            /* 确认密码校验 */
            pwdCheck (rule, value, callback) {
                if (this.agentInfo.confirmPwd !== "") {
                    this.$refs["agentInfo"].validateField("confirmPwd");
                }
                callback();
            },
            /* 协议勾选校验 */
            checkProtocol (rule, value, callback) {
                const msg = "请阅读并同意" + this.hasAgr;
                this.$util.validateProtocol(rule, value, callback, msg);
            },
            /* 是否存在协议 */
            protocol (val) {
                this.hasAgr = val !== "" ? val : false;
            },
            /* 校验证件号码 */
            checkCertNo (rule, value, callback) {
                this.$util.validateCertNo(rule, value, callback, this.agentInfo.certType,true);
            },
            /* 确认密码校验 */
            confirm (rule, value, callback) {
                if (this.agentInfo.pwd !== this.agentInfo.confirmPwd && this.agentInfo.pwd !== "") {
                    callback(new Error("输入密码和确认密码不一致"));
                } else {
                    callback();
                }
            },
            /* 密码显示或隐藏处理 */
            pwdTypeChange () {
                this.pwdType = this.pwdType === "text" ? "password" : "text";
                this.iconCla = this.pwdType === "text" ? "fa fa-eye" : "fa fa-eye-slash";
            },
            // 再次校验证件号码
            checkCertNoAgain () {
                this.$refs.agentInfo.validateField("certNo");
            },
            /* 提交表单数据 */
            mobileCheck () {
                const _all = ["userName","certType","certNo","validdate","mobilecycode","mobile"];
                let _str = "";
                for(let i = 0;i < _all.length;i++){
                    this.$refs.agentInfo.validateField(_all[i],str => {
                        _str = str;
                        return false;
                    });
                    if(!_str){
                        continue;
                    }else{
                        break;
                    }
                }
                if(_str)return false;
                this.visible = true;
            },
            dateInterval (val) {
                this.agentInfo.validdate = val !== null ? val.replace(/-/g, "") : "";
                this.$refs.agentInfo.validateField("validdate");
            },
            // 图片验证码,发送验证码
            getVerifyCode(val){
                this.visible = false;
                const _this = this;
                if (val) {
                    const data = {
                        mobile: this.agentInfo.mobile,
                        verifycode: val,
                        certificateno: this.agentInfo.certNo,
                        certificatetype: this.agentInfo.certType
                    };
                    this.$util.request("acct/orgregister/sendsms",data,"POST").then(res=>{
                        if(res.data){
                            if(res.data[0].wateflag === "1"){
                                _this.$confirm(res.msg, "开户提示", {
                                    confirmButtonText: "登录",
                                    cancelButtonText: "继续",
                                    type: "warning",
                                    customClass: "info-check"
                                }).then(() => {
                                    _this.$router.replace({name: "login"});
                                }).catch(()=>{});
                                return;
                            }
                            _this.time = res.data[0].sendperiod;
                            _this.checked = true;
                            _this.$util.btnDisabled(_this);
                        }else{
                            _this.$message({
                                type: "warning",
                                message: res.msg
                            });
                        }
                    });
                }
            },
            submitForm(name){
                const _this = this;
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        if(!this.checked){
                            _this.$confirm("请先发送手机验证码!", "开户提示", {
                                confirmButtonText: "确认发送",
                                cancelButtonText: "再看看",
                                type: "warning",
                                customClass: "info-check"
                            }).then(()=>{
                                _this.mobileCheck();
                            }).catch(() => {});
                            return;
                        }
                        const data = {
                            tcustfullname: this.agentInfo.userName,
                            tcertificatetype: this.agentInfo.certType,
                            tcertificateno: this.agentInfo.certNo,
                            tvaliddate: this.agentInfo.validdate,
                            tmobilenocycode: this.agentInfo.mobilecycode,
                            tmobileno: this.agentInfo.mobile,
                            temail: this.agentInfo.email,
                            verifycode: this.agentInfo.verifyCode,
                            loginpwd: this.$util.enc(this.agentInfo.pwd),
                            confirmpwd: this.$util.enc(this.agentInfo.confirmPwd)
                        };
                        this.$util.request("orgopen/transinfo",data,"POST").then(res=>{
                            if(res.data){
                                _this.$store.dispatch("putTransid", res.data[0].transid).then(() => {
                                    _this.$router.replace({name: "orgtype"});
                                });
                            }else {
                                this.$message.error(res.msg);
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            mustNum (val, param) {
                const _x = this.$util.filterNum(val);
                this.$set(this.agentInfo, param, _x);
            }
        }
    };
</script>
<style lang="scss">
    .view-agent-info {
        margin-top: 5px;
        padding: 10px 55px;
    .agent-form{
    .el-select{width: 50%;}
    }
    /*颜色，背景写在css/theme.scss内views style下*/
    }
</style>
